import { useEffect, useState } from "react";

export default function useMe() {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await fetch(`${import.meta.env.VITE_API_BASE_URL}/v1/auth/me`, {
        credentials: "include",
      });
      if (!r.ok) {
        // 401 or any failure => not logged in
        setMe(null);
      } else {
        const j = await r.json().catch(() => null);
        // Only accept as logged-in if we have an email
        if (j && j.email) setMe(j);
        else setMe(null);
      }
    } catch {
      setMe(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);
  return { me, loading, refresh: load };
}
